import React from 'react';
import { useLocation } from 'react-router-dom';

import CesiumViewer from '../viewer/CesiumViewer';
import { CesiumErrorBoundary } from '../viewer/components/CesiumErrorBoundary';
import { ProfileProvider } from '../viewer/context/ProfileContext';

function CesiumViewerWrapper() {
  const { state } = useLocation();
  const {
    mappingAssetId,
    gaussianSplattingId,
    resultsAssetId,
    cesium_token,
    transformationPointsId,
    transformationPointsStr,
    transformationGsId,
    transformationGsStr,
  } = state;

  return (
    <div
      style={{
        position: 'fixed',
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
        width: '100%',
        height: '100%',
        overflow: 'hidden',
      }}
    >
      <CesiumErrorBoundary>
        <ProfileProvider>
          <CesiumViewer
            id={mappingAssetId}
            token={cesium_token}
            gaussianSplattingId={gaussianSplattingId}
            resultsAssetId={resultsAssetId}
            transformationPointsId={transformationPointsId}
            transformationPointsStr={transformationPointsStr}
            transformationGsId={transformationGsId}
            transformationGsStr={transformationGsStr}
          />
        </ProfileProvider>
      </CesiumErrorBoundary>
    </div>
  );
}

export default CesiumViewerWrapper;
